import axios from 'axios';

export type CodePromosResponse = {
  data: CodePromoResponse[];
};

export type CodePromoResponse = {
  id: string;
  active: boolean;
  offerName: string;
  // numberOfClick: number; a récupérer via matomo
  codePromo?: string;
  startDate: string;
  endDate: string;
  restaurantId: string;
  appliesOn?: string;
  conditions?: string;
};

export const fetchCodePromoRestaurantRequest = async (codePromoId: string): Promise<CodePromoResponse> => {
  const { data } = await axios.get<CodePromoResponse>(`/protected/promo-code/${codePromoId}`);
  return data;
};

export const fetchCodePromosRestaurantRequest = async (restaurantId: string): Promise<CodePromoResponse[]> => {
  const { data } = await axios.get<CodePromoResponse[]>(`/protected/restaurant/${restaurantId}/promo-code`);
  return data;
};

export const updateOrCreateCodePromoRestaurantRequest = async (codePromo: CodePromoResponse): Promise<CodePromoResponse> => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { id, ...codePromoData } = codePromo;
  const { data } = await axios.put<CodePromoResponse>(`/protected/promo-code/${codePromo.id}`, codePromoData);
  return data;
};

export const patchCodePromoRestaurantRequest = async (couponId: string, codePromo: Partial<CodePromoResponse>): Promise<CodePromoResponse> => {
  const { data } = await axios.patch<CodePromoResponse>(`/protected/promo-code/${couponId}`, codePromo);
  return data;
};

export const deleteCodePromoRestaurantRequest = async (codePromoId: string): Promise<void> => {
  const { data } = await axios.delete<void>(`/protected/promo-code/${codePromoId}`);
  return data;
};
